<template>

  <div class="film" v-track="{act: 'ready', data: {id: 353, p: [filmId]}}">

    <div class="film-header" :class="showHeader || showAlbum? 'show-film-header': ''">
      <div class="goBack" @click="goBack">
        <img src="../../../../image/film/iconRoundReturnCopy@2x.png" alt="">
      </div>
      <div class="title" v-if="!showAlbum">{{filmName}}</div>
      <div class="title" v-if="showAlbum">剧照（{{photosList.length}}）</div>
    </div>

    <!-- <div class="film-poster">
      <img :src="poster | rewriteLink" alt="">
    </div> -->
    <lazy-img class="film-poster" :src="poster" alt="filmPoster" width="100%"></lazy-img>

    <div class="film-detail">
      <div class="col">
        <div class="film-name">
          <span class="name">{{filmName}}</span><span class="item">{{itemName.name}}</span>
        </div>
        <div class="film-grade">
            <span class="grade">{{grade}}</span>
            <span class="grade-text" v-if="!!grade">分</span>
        </div>
      </div>
      <div class="film-category grey-text" v-html="resolveCategory(category)">
      </div>
      <div class="film-premiere-time grey-text">
          {{premiereTime}}
      </div>

      <div class="film-nation-runtime grey-text">
          {{nation}} | {{runtime}}分钟
      </div>

      <div class="test grey-text" ref="test">{{synopsis}}</div>
      <div class="film-synopsis grey-text" :style="`height:${synopsisH}px;`" ref="synopsis" :class="isShowAll? '': 'hidde'" >{{synopsis}}</div>
      <div class="toggle" v-show="isToggle" @click="showAll">
          <img src="../../../../image/film/toggle.png" alt="" :class="isShowAll? 'upper': ''">
      </div>
    </div>
    <div class="actors">
      <div class="actors-title-bar">
        <span class="actors-title-text">演职人员</span>
      </div>
      <template v-if="actorsList.length != 0">
        <row-scroll class="actors-list" height="140px">
          <row-scroll-item v-for="actors in actorsList" :key="actors.name" width="85px">
            <div class="actors-item" style="text-align:center;">
              <lazy-img :src="actors.avatarAddress" class="actors-img" height="85px" width="85px"></lazy-img>

              <!-- <img :src="actors.avatarAddress" class="actors-img" style="height:85px;width:85px;" alt=""> -->
              <span class="actors-name">{{actors.name}}</span>
              <span class="actors-role">{{actors.role}}</span>
            </div>
          </row-scroll-item>
        </row-scroll>
      </template>
      <template v-else>
        <div class="empty-text" style="height:140px;line-height:70px;">暂无演职人员</div>
      </template>
    </div>
    <div class="photos" :class="{'noSale' : !isSale}">
        <div class="photos-title-bar">
          <span class="photos-title-text">剧照</span>
          <span class="photos-to-all" @click="openAlbum" v-if="photosList.length">全部({{photosList.length}})<Icon size="13">quanju_liebiaojiantou</Icon></span>
        </div>

        <template v-if="photosList.length != 0">
          <row-scroll class="photos-list" height="115px">
            <row-scroll-item v-for="(photos, index) in photosList" :key="photos" class="photos-item-wrap" width="150px">
              <div class="photos-item" @click="openBigPhoto(photos,index)">
                <lazy-img :src="photos" class="photos-img" height="100px" width="150px"></lazy-img>
              </div>
            </row-scroll-item>
          </row-scroll>
        </template>

        <template v-else>
          <div class="empty-text" style="height:115px;line-height:58px;">暂无电影剧照</div>
        </template>
    </div>

    <router-link :to="`/film/${filmId}/cinemas`" v-show="isSale" style="height: 49px;position: fixed;
    bottom: 0;
    width: 100%;">
        <div class="goSchedule">
          选座购票
        </div>
    </router-link>

    <div class="album-zone" v-if="showAlbum">
      <div class="all-photos">
        <div @click="openBigPhoto(photos,index)" v-for="(photos, index) in photosList" :key="index" class="photo-context" >
            <!-- <img :src="photos" alt="" style="height:100%;width:100%;" > -->
            <lazy-img :src="photos" width="100%" height="100%" class="album-photo"/>
          </div>
      </div>
    </div>

    <div class="big-photo-zone" v-if="showBigPhoto">
      <div class="big-photo">
        <div class="header">
          <div @click="hideBigPhoto"><Icon class="goBack" :size='22'>tubiaoguifan2</Icon></div>
          <div class="title">{{phototIndex}}/{{photosList.length}}</div>
          <!-- <a class="download-pic" :download="photosList[phototIndex-1]" :href="photosList[phototIndex-1]"><Icon class="" :size='22'> icon-icon_fuli</Icon></a> -->
        </div>
        <mt-swipe :auto="0" :defaultIndex="phototIndex-1" :showIndicators="false" :continuous="false" @change="handlePhototIndex">
          <mt-swipe-item v-for="(photos, index) in photosList" :key="index" >
            <!-- <a class="photo" :style="'background-image: url('+photos+')'"></a> -->
            <!-- <div> -->
            <img :src="photos | rewriteLink" width="100%" class="photo"/>
            <!-- </div> -->
          </mt-swipe-item>
        </mt-swipe>
      </div>
    </div>


  </div>

</template>
<script>
import { resolvePremiereTimeFormat } from "../../../util/function";
import moment from "moment";
import lazyImg from "../../../components/lazy-img";
import Icon from "../../../components/icon";
import rowScroll from "../../../components/row-scroll";
import rowScrollItem from "../../../components/row-scroll-item";
import { mapState, mapActions } from "vuex";
import { Swipe, SwipeItem, MessageBox } from "mint-ui";

export default {
  data() {
    return {
      poster: "",
      synopsisH: 0,
      filmId: this.$route.params.id,
      isToggle: true,
      isShowAll: false,
      scrollY: 0,
      showHeader: false,
      showAlbum: false,
      showBigPhoto: false,
      phototIndex: 0,
      routefromName: "",
    };
  },
  components: {
    Icon,
    "lazy-img": lazyImg,
    [rowScroll.name]: rowScroll,
    [rowScrollItem.name]: rowScrollItem,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.routefromName = from.name
    })
  },
  beforeRouteLeave(to, from, next) {
    if (this.showAlbum) {
      this.hideScroll()
      this.showAlbum = false;
      next(false);
    }
    next(true);
  },
  mounted() {
    window.scrollTo(0, 0);
    window.addEventListener("scroll", this.handleScroll);
    const vm = this;
    this.getFilmInfo({
      filmId: vm.filmId
    }).then(res => {
      vm.poster = res.film.poster;
      setTimeout(() => {
        vm.synopsisH = vm.$refs.test.clientHeight;
      }, 200);
      // if(this.synopsisH < 38){
      //   vm.isToggle = false
      // }else{
      //   vm.isShowAll = false
      // }
        if(!vm.isSale)
        MessageBox({
            message:'该影片目前没有排期，到首页看其他电影吧',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '同意',
            confirmButtonHighlight: true,
            cancelButtonText: '拒绝',
            closeOnClickModal: false,
        }).then(action => {
            if(action == 'confirm') {
                this.$router.push({name: 'home'})
            }
        })
    });
  },
  computed: {
    ...mapState({
      // poster: state => state.film.filmInfo.poster || "",
      filmName: state => state.film.filmInfo.name || "",
      itemName: state => state.film.filmInfo.item || "",
      category: state => state.film.filmInfo.category || "",
      nation: state => state.film.filmInfo.nation || "",
      runtime: state => state.film.filmInfo.runtime || "",
      grade: state => state.film.filmInfo.grade || "",
      synopsis: state => state.film.filmInfo.synopsis || "",
      actorsList: state => state.film.filmInfo.actors || [],
      photosList: state => state.film.filmInfo.photos || [],
      isSale: state => state.film.filmInfo.isSale || ""
    }),
    filmInfo() {
      return this.$store.state.film.filmInfo || {};
    },
    premiereTime() {
      if (this.filmInfo.timeType == 1 || this.filmInfo.timeType == 2) {
        return `${resolvePremiereTimeFormat(this.filmInfo)}`;
      } else {
        return `${resolvePremiereTimeFormat(this.filmInfo)}上映`;
      }
    }
  },
  watch: {
    scrollY: function(curVal, oldVal) {
      if (curVal <= 30) {
        this.showHeader = false;
      } else {
        this.showHeader = true;
      }
    }
  },
  methods: {
    ...mapActions(["getFilmInfo"]),
    showAll() {
      this.isShowAll = !this.isShowAll;
    },
    goBack() {
      if (this.showAlbum) {
        this.hideScroll();
        return (this.showAlbum = false);
      }
      this.$router.go(-1);
    },
    handleScroll: function() {
      this.scrollY = window.scrollY;
    },
    openAlbum() {
      if (this.photosList.length == 0) {
        return;
      }
      this.showAlbum = true;
      this.showScroll();
    },
    openBigPhoto(photos, index) {
      this.showBigPhoto = true;
      this.phototIndex = index + 1;
    },
    hideBigPhoto() {
      this.showBigPhoto = false;
      this.phototIndex = 0;
    },
    handlePhototIndex(index) {
      this.phototIndex = index + 1;
    },
    showScroll() {
      this.offsetTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop;
      const html = document.getElementsByTagName("html")[0];
      html.className += " hideScroll";
    },
    hideScroll() {
      const html = document.getElementsByTagName("html")[0];
      html.className = html.className.replace(" hideScroll", "");
      document.documentElement.scrollTop = document.body.scrollTop = this.offsetTop;
    },
    resolveCategory(val) {
      if(val) {
        let newVal = val.split('|')
        return newVal.join(' | ')
      }
      return val
    }
  }
};
</script>
<style lang="less">
@import "../../../../stylesheet/variable.less";
@battleshipGrey: rgb(121, 125, 130);
@silver: rgb(189, 192, 197);
@textBlack: rgb(25, 26, 27);
@reddish: rgb(192, 49, 49);
@butterscotch: rgb(255, 178, 50);

.film {
  .test {
    width: calc(~"100vw - 30px");
    opacity: 0;
    position: absolute;
    top: 1px;
    margin-left: -10000px;
    font-size: 13px;
  }
  .film-header {
    position: fixed;
    background-color: rgba(255, 255, 255, 0);
    color: transparent;
    transition: all 0.3s ease;
    width: 100vw;
    height: 44px;
    z-index: 1;
    .goBack {
      height: 30px;
      position: absolute;
      top: 5px;
      left: 5px;
      img {
        width: 30px;
      }
    }
    .title {
      font-size: 17px;
      line-height: 44px;
      width: 100vw;
      text-align: center;
    }
  }
  .show-film-header {
    transition: all 0.3s ease;
    background-color: rgba(255, 255, 255, 1);
    color: @textBlack;
    &::after {
      .setBottomLine();
    }
  }
  // .film-poster {
  //   width: 100vw;
  //   height: calc(~"(420 / 750) * 100vw");
  //   img {
  //     width: 100%;
  //     display: block;
  //   }
  // }
  .film-detail {
    padding: 15px;
    padding-top: 12px;
    background-color: #fff;
    .col {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
    .grey-text {
      font-size: 13px;
      color: @battleshipGrey;
      margin-top: 4px;
    }
    .film-name {
      width: 256px;
      span {
        // display: inline-block;
        vertical-align: middle;
      }
      .name {
        color: @textBlack;
        font-size: 18px;
        height: 24px;
        line-height: 24px;
        margin-right: 7px;
      }
      .item {
        font-size: 9px;
        color: #fff;
        background-color: #D2D6DC;
        height: 14px;
        line-height: 14px;
        padding: 0 2px;
        border-radius: 2px;
        display: inline-block;
      }
    }
    .film-grade {
      width: calc(~"100% - 250px");
      text-align: right;
      color: @butterscotch;
      .grade {
        font-size: 18px;
        font-style: italic;
      }
      .grade-text {
        font-size: 10px;
      }
    }
    .film-synopsis {
      margin-top: 12px;
      // max-height: 500px;
      transition: height 0.5s ease;
    }
    .hidde {
      height: 38px !important;
      overflow: hidden;
      transition: height 0.5s ease;
    }
    .toggle {
      text-align: center;
      display: block;
      height: auto;
      width: 20px;
      margin: auto;
      line-height: initial;
      img {
        width: 8px;
        margin: auto;
      }
    }
    .upper {
      transform: rotate(180deg);
    }
  }
  .actors {
    margin-top: 10px;
    background-color: #fff;
    .actors-title-bar {
      width: 100%;
      padding: 15px;
      span {
        display: inline-block;
        height: 22.5px;
        line-height: 22px;
      }
      .actors-title-text {
        font-size: 16px;
        text-align: left;
        color: @textBlack;
      }
    }
    .actors-item {
      span {
        display: block;
        text-align: center;
      }
    }
    .actors-name {
      padding-top: 10px;
      font-size: 12px;
      color: @textBlack;
      width: 85px;
      height: 18px;
      display: block;
      .dotOverflow();
    }
    .actors-role {
      font-size: 10px;
      color: @battleshipGrey;
    }
  }

  .photos {
    margin-top: 10px;
    margin-bottom: 60px;
    background-color: #fff;
    .photos-title-bar {
      height: 62px;
      width: 100%;
      padding: 15px;
      span {
        display: inline-block;
        height: 22.5px;
        line-height: 22px;
      }
      .photos-title-text {
        font-size: 16px;
        text-align: left;
        color: @textBlack;
      }
      .photos-to-all {
        font-size: 13px;
        color: @battleshipGrey;
        float: right;
      }
    }
    .photos-item-wrap {
      width: auto !important;
    }
    .photos-item {
      span {
        display: block;
        text-align: center;
      }
    }
  }
  .empty-text {
    font-size: 14px;
    color: @silver;
    margin: auto;
    text-align: center;
    line-height: 100%;
  }
  .goSchedule {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 49px;
    width: 100%;
    text-align: center;
    background-color: @orange;
    color: #fff;
    font-size: 16px;
    line-height: 49px;
    &:active {
      background: #e55513;
      color: rgba(255, 255, 255, 0.6);
    }
  }
  .noSale {
    margin-bottom: 10px;
  }
  .album {
    width: 100%;
    height: 100%;
    z-index: 3000;
    position: fixed;
    background-color: #fff;
    top: 0;
    .header {
      position: fixed;
      width: 100vw;
      height: 44px;
      color: @textBlack;
      .goBack {
        height: 44px;
        width: 44px;
        position: absolute;
        top: 5px;
        left: 7px;
        color: @textBlack;
      }
      .title {
        font-size: 17px;
        line-height: 45px;
        width: 100vw;
        text-align: center;
      }
      &::after {
        .setBottomLine();
      }
    }
  }
  .big-photo {
    width: 100%;
    height: 100%;
    z-index: 3001;
    position: fixed;
    background-color: #000;
    top: 0;
    .header {
      position: fixed;
      width: 100vw;
      height: 44px;
      color: white;
      z-index: 5;
      .goBack {
        height: 44px;
        width: 44px;
        position: absolute;
        top: 5px;
        left: 7px;
        color: white;
      }
      .title {
        font-size: 17px;
        line-height: 45px;
        width: 100vw;
        text-align: center;
      }
      .download-pic {
        height: 44px;
        width: 44px;
        position: absolute;
        top: 5px;
        right: 7px;
        color: white;
      }
    }
    .mint-swipe {
      overflow: hidden;
      position: relative;
      height: 100%;
      z-index: 3;
      .mint-swipe-item {
        // transform-origin: 50% 50%;
        display: inline-flex !important;
        align-items: center;
      }
      .photo {
        display: block;
        width: 100%;
        // height: 100%;
        // background-repeat: no-repeat;
        // background-position: 50% 40%;
        // background-size: contain;
        // user-select: all;
      }
    }
  }
  .album-zone {
    position: fixed;
    top: 44px;
    left: 0;
    right: 0;
    bottom: 0;
    overflow-y: auto;
    background-color: #fff;
    .all-photos {
      display: flex;
      justify-content: flex-start;
      align-content: center;
      flex-wrap: wrap;
    }
    .photo-context {
      width: calc(~"(100vw - 3px)/3");
      height: calc(~"(100vw - 3px)/3");
      margin-bottom: 1.5px;
      background-size: 80px;
      background-position: 50%;
      background-repeat: no-repeat;
      margin-right: 1.5px;
      background-image: url(../../../../../image/sdyx_padding.png);
    }
    .photo-context:nth-child(3n) {
      margin-right: 0px;
    }
    .album-photo {
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
}
</style>
